import React from 'react';
import { popoverIds, popoverTerms, tabs } from '../../../constants/suggestedAgents';
import { columns } from '@lwt-helix/helix-icon/outlined';
import { views } from '../../../constants/savedAgents';
import { agentProductionTerms as apt } from '../../../../constants';
import { Display } from '../Display';
import { HelixIcon } from '@lwt-helix/helix-icon';
import DropDownOption from '../../common/DropDownOption';
import GrowthAnalysisPeriodDropdown from '../../common/GrowthAnalysisPeriodDropdown';
import { getHeaderText } from '../../../helpers/listingProficiencyHelpers';
import MetricsSelector from '../../MetricsSelector';

export const getAllSearchFiltersProps = args => {
    const {
        tabKey,
        shouldShowPopoverById,
        togglePopover,
        searchOptions,
        hasResults,
        tableSettings,
        selectedListingViewId,
        growthAnalysisPeriod,
    } = args;
    const { display, metrics } = popoverIds;

    return [
        ...( hasResults ? [{
            dataLwtId: `${tabKey}-${display}`,
            popoverInnerClassName: 'popover-menu-width-224',
            popoverPlacement: popoverTerms.bottomEnd,
            popoverIsOpen: shouldShowPopoverById[display],
            togglePopover: () => togglePopover(display),
            mainTitle: apt?.[searchOptions?.[tabKey]?.display?.selectedView?.value] ?? '',
            popoverBody: <Display togglePopover={() => togglePopover(display)} />
        },
        {
            dataLwtId: `${tabKey}-${metrics}`,
            popoverInnerClassName: 'popover-menu-width-800 helix-heading',
            popoverPlacement: popoverTerms.bottomEnd,
            popoverIsOpen: shouldShowPopoverById[metrics],
            popoverClassName: tableSettings?.className,
            popoverHeader: selectedListingViewId === views.listingProficiency ? getHeaderText() : apt.metrics,
            togglePopover: () => togglePopover(metrics),
            mainTitle: <HelixIcon icon={columns} className='mr-2' />,
            popoverBody: <MetricsSelector
                columns={tableSettings?.columns}
                setColumns={tableSettings?.setColumns}
                tabMode={selectedListingViewId}
                customSettings={{growthAnalysisPeriod, currentTabId: tabKey}}
            />,
        }] : []),
    ];
};

export const getSearchFiltersByTab = args => {
    const { growthAnalysisPeriod, setGrowthAnalysisPeriod, tabKey, searchOptions, suggestedAgentsState } = args;
    const validationMessage = suggestedAgentsState?.validationSettings?.validationMessage
    const filters = getAllSearchFiltersProps(args)
        .map(props => <DropDownOption key={props.dataLwtId} {...props} validationMessage={validationMessage}/>);
    const shouldShowGrowthAnalysisTimePeriod = ![tabs.incProducers.id, tabs.decProducers.id].includes(tabKey);
    const isGrowthAnalysisView = searchOptions[tabKey].display.selectedView.value === views.growthAnalysis;
    if (shouldShowGrowthAnalysisTimePeriod && isGrowthAnalysisView) {
        return [
            filters[0],
            <GrowthAnalysisPeriodDropdown
                key={`${tabKey}-${popoverIds.growthAnalysisPeriod}`}
                growthAnalysisPeriod={growthAnalysisPeriod}
                setGrowthAnalysisPeriod={setGrowthAnalysisPeriod}
            />,
            ...filters.slice(1),
        ];
    }
    return filters;
};
